import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {packageTypeAction, productAction} from "../../actions";
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Autocomplete from '@mui/lab/Autocomplete/Autocomplete';
import Chip from "@mui/material/Chip";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {Link, useLocation, useNavigate} from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CreateIcon from "@mui/icons-material/Create";
import CurrencyFormat from "react-currency-format";
import ProductExcelDownload from "../../components/Product/excel";
import HeadLine from "../../components/HeadLine/headLine";
import {makeStyles} from '@mui/styles';
import ButtonGroup from '@mui/material/ButtonGroup';
import Modal from "@mui/material/Modal";
import queryString from 'query-string';
import ReactPaginate from "react-paginate";

const Products = ( props ) => {
    const history = useNavigate()
    const location = useLocation();
    const query = queryString.parse(location.search);

    const { fetchProducts, productReducer, packageTypeReducer, fetchPackageType } = props

    const [deleteFileModal, setDeleteFileModal] = useState(false);
    const [page, setPage] = useState(parseInt(query.page) || 1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(100);
    const [brands, setBrands] = useState([]);

    const [filter, setFilter] = useState({
        status : query.status || 1,
        count : query.count || -1,
        title : query.title || -1,
        id : query.id || -1,
        brand_id : query.brand_id || -1,
        package_type_id : query.package_type_id || -1,
        discount : query.discount || -1,
    });


    useEffect(() => {
        fetchPackageType();
        new Api().get(`/products/brands`).then((response) => {
            if (typeof response !== "undefined") {
                setBrands(response)
            }

        })
    }, []);

    const handleChangeSearchInput = (event) => {
        setPage(1)
        const modifiedQuery = {...query,[event.target.name]: event.target.value}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }

        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );

        let search = filter;

        search[event.target.name] = event.target.value;

        setFilter({...search})

    }
    // const useStyles = makeStyles((theme) => ({
    //     root: {
    //         display:"flex",
    //         alignItems:'center',
    //         justifyContent:"center"
    //     },
    //     modal: {
    //         display: 'flex',
    //         padding: theme.spacing(1),
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //     },
    //     paper: {
    //         width: 400,
    //         backgroundColor: theme.palette.background.paper,
    //         border: '2px solid #000',
    //         boxShadow: theme.shadows[5],
    //         padding: theme.spacing(2, 4, 3),
    //     },
    // }));
    // const classes = useStyles();
    const classes = {};
    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        const modifiedQuery = {...query,[name]: value}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }
        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );

        let search = filter;

        search[name] = value;

        setFilter({...search})

    }



    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, page, filter]);


    const handleRequest = () => {
        const modifiedQuery = {...query,["page"]: page}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }
        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );
        fetchProducts({
            filter,
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        })


    };



    const handleChangeStatus = (id, field) => {
        new Api().put('/products/' + id + '/status', {field}).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    const handleDeleteProduct = (id) => {
        new Api().delete('/products/' + id + '/delete')
            .then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                    setDeleteFileModal(null)
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    const pageCount = Math.ceil(parseInt(productReducer?.entities.total) / parseInt(productReducer?.entities.per_page));


    return(
        <div style={{ padding: '0 20px'}}>
            <HeadLine
                title={"مدیریت محصولات"}
                subTitle={"محصولات را مدیریت کنید."}
            />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    type={"search"}
                                    label="کد محصول"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                    value={filter.id}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    type={"search"}
                                    label="کد انبار"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                    value={query.code}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    type={"search"}
                                    label="نام محصول"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                    value={query.title}

                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={3} >
                                <Autocomplete
                                    onChange={((event, value) => handleChangeSearchInputWithAutoComplete('brand_id', value ? value.id : '-1'))}
                                    options={brands.data}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            margin={"dense"}
                                            label="برند"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}

                                        />
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={3} >
                                <Autocomplete
                                    onChange={((event, value) => handleChangeSearchInputWithAutoComplete('package_type_id', (value ? value.id : '') ))}
                                    options={packageTypeReducer?.entities?.data}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            name='package_type_id'
                                            margin={"dense"}
                                            label="واحد اندازه گیری"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    type={"search"}
                                    label="موجودی"
                                    value={query.count}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='count'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>دارد</MenuItem>
                                    <MenuItem key={2} value={0}>ندارد</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    value={query.status}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>فعال</MenuItem>
                                    <MenuItem key={2} value={0}>غیرفعال</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="تخفیف"
                                    value={query.discount}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='discount'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>دارد</MenuItem>
                                    <MenuItem key={2} value={0}>ندارد</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <ProductExcelDownload object={{
                    filter,
                    sort_field: sort_field,
                    sort_type: sort_type,
                    page: page,
                    limit: limit
                }} />
                <Tooltip title="افزودن">
                    <Link to={'/product/updateOrCreate'}>
                        <IconButton>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Link>
                </Tooltip>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('id')} } >#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('title')} } >نام &nbsp;{sort_field === 'title' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th>تنوع محصول</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('brand_id')} } >برند &nbsp;{sort_field === 'brand_id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('package_type_id')} } >واحد&nbsp;{sort_field === 'package_type_id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('count')} } >موجودی&nbsp;{sort_field === 'count' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('price')} } >قیمت (تومان)&nbsp;{sort_field === 'price' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('discount')} } >تخفیف (درصد)&nbsp;{sort_field === 'discount' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('weight')} } >وزن پستی (گرم)&nbsp;{sort_field === 'weight' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('sales_number')}}>تعداد فروش&nbsp;{sort_field === 'sales_number' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortType(sort_type === 'asc' ? 'desc' : 'asc');setSortField('status')} } >وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th>عملیات</th>
                            <th>حذف</th>
                        </tr>
                        </thead>
                        <tbody>
                        {productReducer.entities.data && productReducer.entities.data.map((entity, index) => {
                            return(
                                <tr  style={{ backgroundColor: (entity.count <= entity.order_point || entity.count <= 0 ? '#d7c343' : '') }} key={index}>
                                    <td>{entity.id}</td>
                                    <td  onClick={() => {window.location.assign(`https://digiattar.com/product/${entity.id}`)}}><b>{entity.title}<br/>{(entity.types && entity.types.length > 0 && entity.types[0].title && entity.types[0].title)}</b></td>
                                    <td>{entity.types && entity.types.length > 0 ? entity.types.length : 0}</td>
                                    <td>{entity.brand ? entity.brand.title : '-'}</td>
                                    <td>{entity.package_type ? entity.package_type.title : '-'}</td>
                                    <td><CurrencyFormat value={entity.types && entity.types.length > 0 && entity.types[0].count ?  entity.types[0].count : 0}  displayType={'text'} thousandSeparator={true}  /></td>
                                    <td><CurrencyFormat value={entity.types && entity.types.length > 0 && entity.types[0].price ? entity.types[0].price : 0}  displayType={'text'} thousandSeparator={true}  /></td>
                                    <td><CurrencyFormat value={entity.types && entity.types.length > 0 && entity.types[0].discount ? entity.types[0].discount : 0}  displayType={'text'} thousandSeparator={true}  /></td>
                                    <td><CurrencyFormat value={entity.types && entity.types.length > 0 && entity.types[0].weight ? entity.types[0].weight : 0}  displayType={'text'} thousandSeparator={true}  /></td>
                                    <td><CurrencyFormat value={entity.types && entity.types.length > 0 && entity.types[0].sales_number ? entity.types[0].sales_number : 0}  displayType={'text'} thousandSeparator={true}  /></td>
                                    <td>
                                        <Tooltip title="وضعیت">
                                            <Chip size={"small"} variant={"outlined"} color={+entity.status === 1 ? "primary": "secondary"}  label={+entity.status === 1 ? 'فعال' : 'غیرفعال'} clickable={true} onClick={() => handleChangeStatus(entity.id, 'status')} />
                                        </Tooltip>
                                    </td>
                                    <td onClick={() => (localStorage.setItem("p-name" , entity.title))}>
                                        <Tooltip title="ویرایش">
                                            <Link to={{
                                                pathname:`/product/updateOrCreate/${entity.id}`,
                                            }}>
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Tooltip title="حذف">
                                            <Chip size={"small"} variant={"outlined"} color={ "secondary"}  label={"حذف"} clickable={true} onClick={() => {
                                                setDeleteFileModal(entity.id);
                                            }} />
                                        </Tooltip>
                                    </td>
                                    <div className={classes.root} >
                                        <Modal
                                            disablePortal
                                            disableEnforceFocus
                                            disableAutoFocus
                                            open={deleteFileModal === entity.id}
                                            onClose={() => {
                                                setDeleteFileModal(null)
                                            }}
                                            aria-labelledby="server-modal-title"
                                            aria-describedby="server-modal-description"
                                            className={classes.modal}
                                            // container={() => rootRef.current}

                                        >
                                            <div className={"modal"}>
                                                <div>
                                                    <h2 id="server-modal-title">آیا از ادامه عملیات مطمئن هستید ؟</h2>
                                                    <ButtonGroup
                                                        color="primary"
                                                        aria-label="outlined primary button group"
                                                        dir={"rtl"}
                                                    >
                                                        <div dir="rtl">
                                                            <Button
                                                                color="primary"
                                                                onClick={() => {
                                                                    handleDeleteProduct(entity.id)
                                                                }}
                                                                style={{marginLeft: "10px"}}
                                                            >
                                                                بله
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                onClick={() => {
                                                                    setDeleteFileModal(null)
                                                                }}
                                                            >
                                                                خیر
                                                            </Button>
                                                        </div>
                                                    </ButtonGroup>

                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                </tr>
                            );
                        }
                        )}
                        </tbody>
                    </table>
                </div>


                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </>
        </div>

    );
}


const mapStateToProps = state => ({
    packageTypeReducer: state.packageTypeReducer,
    productReducer: state.productReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageType: (object) => {
        dispatch(packageTypeAction.fetchPackageType())
    },
    fetchProducts: (object) => {
        dispatch(productAction.fetchProducts(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Products)
